/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Last_UpdatedInputs */

const en_terms_last_updated = /** @type {(inputs: Terms_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: July 30, 2026`)
};

const ko_terms_last_updated = /** @type {(inputs: Terms_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최종 수정: 2026년 7월 30일`)
};

const ja_terms_last_updated = /** @type {(inputs: Terms_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新: 2026年7月30日`)
};

/**
* | output |
* | --- |
* | "Last updated: July 30, 2026" |
*
* @param {Terms_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_last_updated = /** @type {((inputs?: Terms_Last_UpdatedInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Last_UpdatedInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_last_updated(inputs)
	if (locale === "ko") return ko_terms_last_updated(inputs)
	return ja_terms_last_updated(inputs)
});